import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { ReportType } from '~/types/types';
import { useListReferencePeriodsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionMenu',
  props: {
    fund: {
      type: Object,
      required: true
    },
    isConsideringPais: {
      type: Boolean,
      required: true
    },
    isConsideringSfdr: {
      type: Boolean,
      required: true
    },
    consideredReferencePeriods: {
      // Array of reference periods that already exist.
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['submit'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var currentYear = new Date().getFullYear();
    var newReferencePeriod = ref(null);
    var _useListReferencePeri = useListReferencePeriodsQuery({
        filters: {
          isAnnual: true,
          userDefined: false,
          hasLabel: true
        },
        sort: 'asc'
      }),
      result = _useListReferencePeri.result;
    var possibleReferencePeriods = computed(function () {
      var _result$value$listRef, _result$value, _result$value$listRef2;
      return (_result$value$listRef = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$listRef2 = _result$value.listReferencePeriods) === null || _result$value$listRef2 === void 0 ? void 0 : _result$value$listRef2.filter(function (rp) {
        return Number(rp.label) < new Date().getFullYear() + 1;
      })) !== null && _result$value$listRef !== void 0 ? _result$value$listRef : [];
    });
    var unconsideredReferencePeriods = computed(function () {
      return possibleReferencePeriods.value.filter(function (refPeriod) {
        return !props.consideredReferencePeriods.map(function (rp) {
          return rp.id;
        }).includes(refPeriod === null || refPeriod === void 0 ? void 0 : refPeriod.id);
      });
    });
    nextTick(function () {
      if (unconsideredReferencePeriods.value.length > 0) {
        newReferencePeriod.value = unconsideredReferencePeriods.value[0];
      }
    });
    var formattedUnconsideredReferencePeriods = computed(function () {
      return unconsideredReferencePeriods.value.map(function (rp) {
        return {
          text: "Reference period ".concat(rp.label),
          value: rp.id
        };
      });
    });
    var reportTypeString = function reportTypeString(reportType) {
      if (reportType === ReportType.SfdrPeriodic) {
        return 'Periodic';
      } else if (reportType === ReportType.SfdrPai) {
        return 'PAI';
      } else if (reportType === ReportType.SfdrPrecontractual) {
        return 'Precontractual';
      }
    };
    var triggerAddReportAnswer = function triggerAddReportAnswer(referencePeriodId) {
      // Set fund.sfdrReferencePeriod to the relevent period
      console.log('triggerAddReportAnswer.referencePeriodId:', referencePeriodId);
      emit('submit', referencePeriodId);
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      currentYear: currentYear,
      newReferencePeriod: newReferencePeriod,
      result: result,
      possibleReferencePeriods: possibleReferencePeriods,
      unconsideredReferencePeriods: unconsideredReferencePeriods,
      formattedUnconsideredReferencePeriods: formattedUnconsideredReferencePeriods,
      reportTypeString: reportTypeString,
      triggerAddReportAnswer: triggerAddReportAnswer
    };
  }
});